module.exports = __webpack_public_path__ + "static/media/Miyuki.94ceed7e.PNG";